import { Component, Renderer2, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IeWarningModalComponent } from '../ie-warning-modal/ie-warning-modal.component';
import { ActivatedRoute } from '@angular/router';
import { LoginAction } from '../../classes/static/enums';
import { Extensions } from '../../classes/static/extensions';
import { SwitchUsersModalComponent } from '../switch-users-modal/switch-users-modal.component';
import { combineLatest } from 'rxjs';
import { ConnectProfileModalComponent } from '../connect-profile-modal/connect-profile-modal.component';
import { LoginService } from '../../services/login.service';

@Component({
	selector: 'login',
	template: require('./login.component.html'),
	host: { class: 'flex-column min-height-full-vh' },
})
export class LoginComponent implements OnInit {
	constructor(
		private renderer: Renderer2,
		private modalService: NgbModal,
		private route: ActivatedRoute
	) {}
	public action: LoginAction = LoginAction.Login;
	public title: string;

	ngOnInit() {
		combineLatest(this.route.data, this.route.queryParams).subscribe((result) => {
			const routeData = result[0];
			const routeQueryParams = result[1];

			if (routeData['isImpersonation'] == true) {
				this.action = LoginAction.ImpersonationLogin;
			} else if (routeData['linkNewUser'] === true) {
				this.action = LoginAction.LinkUsers;
			} else if (routeData['switchUser'] === true) {
				this.action = LoginAction.SwitchUser;
			} else if (routeData['renewLink'] === true) {
				this.action = LoginAction.RenewLink;
			}
			LoginService.setAction(this.action);

			Extensions.setReturnUrl(routeQueryParams);

			const userIdQueryParam = !!routeQueryParams ? routeQueryParams['userId'] : undefined;
			let modalRef: NgbModalRef;

			setTimeout(() => {
				this.setPageTitle();
				if (this.action === LoginAction.SwitchUser && !!userIdQueryParam) {
					modalRef = this.modalService.open(SwitchUsersModalComponent);
				} else if (this.action === LoginAction.RenewLink && !!userIdQueryParam) {
					modalRef = this.modalService.open(ConnectProfileModalComponent);
					modalRef.componentInstance.isRenew = true;
				}

				if (!!modalRef) {
					modalRef.componentInstance.targetUserId = userIdQueryParam;
				}
			});
		});

		let template: string =
			document.querySelector('meta[name=indexTemplate]') &&
			document.querySelector('meta[name=indexTemplate]').getAttribute('content');
		this.renderer.addClass(document.body, template);
		this.renderer.addClass(document.body.querySelector('img.login-header-img'), template);
		const isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
		if (isIE) {
			this.modalService.open(IeWarningModalComponent);
		}
	}

	private setPageTitle() {
		switch (this.action) {
			case LoginAction.LinkUsers:
				this.title = 'Σύνδεση προφίλ στο i-bank';
				break;
			case LoginAction.RenewLink:
				this.title = 'Ανανέωση σύνδεσης προφίλ';
				break;
			case LoginAction.SwitchUser:
				this.title = 'Αλλαγή προφίλ';
				break;
			case LoginAction.ImpersonationLogin:
					this.title = 'Impersonation Login';
					break;
			default:
				this.title = 'Καλώς ήρθατε στο i-bank';
				break;
		}
	}
}
